import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFeedlyComponent } from './simple-icons-feedly.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFeedlyComponent ],
    exports:      [ SimpleIconsFeedlyComponent ],
    bootstrap:    []
})
export class SimpleIconsFeedlyModule {}
